import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      modelType: '',
      customFields: [],
      customFieldValues: [],
      // when migrating, see if this can be done via a computed property as part of a composable
      // or pass a watcher as part of the composable
      // each file using this watches for changes to the entity and updates the context accordingly, e.g. case_type, plan_type, etc.
      customFieldContext: {},
    };
  },

  created() {
    this.grabCustomFields();
  },

  computed: {
    ...mapGetters('customFields', ['getCustomFieldByModelType']),

    visibleCustomFields() {
      if (!this.customFields || this.customFields.length === 0) return [];
      return this.customFields.filter((field) => this.evaluateFieldConditions(field, this.customFieldContext));
    },
  },

  methods: {
    buildDataBlob(original, clientData) {
      const clientCustomFields = clientData && clientData.custom_fields ? clientData.custom_fields : [];

      if (this.customFields.length > 0) {
        if (original.custom_fields === undefined) {
          original.custom_fields = {};
          this.customFields.forEach((item) => {
            let field = clientCustomFields.find((field) => field.reference === item.reference);
            original.custom_fields[item.reference] = field ? field.value : null;
          });
        } else {
          // working with existing stuff.
          let newObject = {};
          this.customFields.forEach((item) => {
            let field = clientCustomFields.find((field) => field.reference === item.reference);
            newObject[item.reference] = field ? field.value : null;
          });
          original.custom_fields = newObject;
        }
      }
      return original;
    },

    grabCustomFields() {
      this.customFields = this.getCustomFieldByModelType(this.modelType);
    },

    /**
     * Evaluate whether a custom field should be visible based on its conditions
     * and the current entity context.
     *
     * @param {Object} field - The custom field definition
     * @param {Object} context - The entity's current attribute values (e.g. { case_type: 'uuid', plan_type: 'pension' })
     * @returns {boolean}
     */
    evaluateFieldConditions(field, context) {
      // If there are no conditions, the field is visible
      if (!field.conditions || field.conditions.length === 0) {
        return true;
      }

      // If there are conditions but no context, we can't evaluate them, so the field is not visible
      if (!context || Object.keys(context).length === 0) {
        return false;
      }

      const operator = field.conditions_operator || 'all';

      const results = field.conditions.map((condition) => {
        const entityValue = context[condition.attribute];

        if (entityValue === undefined || entityValue === null) {
          return false;
        }

        return condition.values.includes(entityValue);
      });

      if (operator === 'all') {
        return results.every((r) => r === true);
      }

      return results.some((r) => r === true);
    },

    filterTypeConverter(type) {
      switch (type) {
        case 'selection':
          return 'select';
        case 'datetime':
          return 'date';
        default:
          return type;
      }
    },

    filterComponentSelector(type) {
      switch (type) {
        case 'selection':
          return 'FiltersV2ComponentSelect';
        case 'boolean':
          return 'FiltersV2ComponentBooleanSelect';
        case 'datetime':
          return 'FiltersV2ComponentDate';
        default:
          return 'FiltersV2ComponentInput';
      }
    },

    buildForFilters() {
      let output = [];
      this.customFields.forEach((item) => {
        let dataObj = {
          name: item.name,
          field: 'filter[custom_field:' + item.reference + ']',
          type: this.filterTypeConverter(item.type),
          options: item.selection_options,
          component: this.filterComponentSelector(item.type),
          multiple: false,
          open: false,
          custom_field: true,
        };
        output.push(dataObj);
      });
      return output;
    },
  },
};
